import React, { useState, useEffect } from "react";
import Button from "../../components/controls/Button";
import { useTranslation } from "react-i18next";

export default function StoreFilters({
  activeType,
  setActiveType,
  searchTerm,
  handleSearchChange,
  maxPrice,
  minPrice,
  setMinPrice,
  setMaxPrice,
  selectedCompany,
  setSelectedCompany,
  uniqueCompanies = [],
}) {
  const { t } = useTranslation();

  const [tempMinPrice, setTempMinPrice] = useState(minPrice);
  const [tempMaxPrice, setTempMaxPrice] = useState(maxPrice);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMinPrice(tempMinPrice);
      setMaxPrice(tempMaxPrice);
    }, 400);
    return () => clearTimeout(timeout);
  }, [tempMinPrice, tempMaxPrice, setMinPrice, setMaxPrice]);

  return (
    <div className="bg-white rounded-lg shadow p-4 space-y-4 sticky top-24">
      <h2 className="text-lg font-semibold">{t("storeFilters.title")}</h2>

      {/* Catégorie */}
      <div className="flex flex-col space-y-2">
        <label className="font-medium">{t("storeFilters.category")}</label>

        <div className="grid grid-cols-2 gap-2">
          <Button
            as="button"
            type="button"
            onClick={() => setActiveType("product")}
            color={activeType === "product" ? "mint" : "primary"}
            size="md"
            className="w-full px-4 py-2 font-semibold"
            aria-pressed={activeType === "product"}
            aria-label={t("storeFilters.aria.pressProducts")}
          >
            {t("storeFilters.products")}
          </Button>

          <Button
            as="button"
            type="button"
            onClick={() => setActiveType("service")}
            color={activeType === "service" ? "mint" : "primary"}
            size="md"
            className="w-full px-4 py-2 font-semibold"
            aria-pressed={activeType === "service"}
            aria-label={t("storeFilters.aria.pressServices")}
          >
            {t("storeFilters.services")}
          </Button>
        </div>
      </div>

      {/* Recherche */}
      <div>
        <label className="font-medium">{t("storeFilters.search")}</label>
        <input
          type="text"
          placeholder={t("storeFilters.searchPlaceholder")}
          value={searchTerm}
          onChange={handleSearchChange}
          className="input input-bordered w-full"
          aria-label={t("storeFilters.aria.searchByName")}
        />
      </div>

      {/* Prix */}
      <div className="space-y-2">
        <label className="font-medium">{t("storeFilters.price")}</label>
        <div className="flex gap-2 items-center">
          <input
            type="number"
            value={tempMinPrice}
            onChange={(e) => setTempMinPrice(Number(e.target.value))}
            className="input input-bordered w-full"
            aria-label={t("storeFilters.aria.minPrice")}
          />

          <input
            type="number"
            value={tempMaxPrice}
            onChange={(e) => setTempMaxPrice(Number(e.target.value))}
            className="input input-bordered w-full"
            aria-label={t("storeFilters.aria.maxPrice")}
          />
        </div>
      </div>

      {/* Compagnies */}
      {uniqueCompanies.length > 1 && (
        <div>
          <label className="font-medium">{t("storeFilters.company")}</label>
          <select
            className="select select-bordered w-full"
            value={selectedCompany}
            onChange={(e) => setSelectedCompany(e.target.value)}
            aria-label={t("storeFilters.aria.companySelect")}
          >
            <option value="">{t("storeFilters.allCompanies")}</option>
            {uniqueCompanies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
